import { BaseRequestQueryParam, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import {
  FiatTransactionResponseModel,
  OrderSwapRequestModel,
  OrderTransactionResponseModel,
  TransactionResponseModel,
} from 'models/transaction';
import { getLocalStorage } from 'utils/sessionStorage';
import { CoinPairDto, VinpayOrderResponseModel } from 'models/wallet';

const transactionApi = {
  getTransactions: (
    params: BaseRequestQueryParam,
  ): Promise<HttpResponse<TransactionResponseModel[]>> => {
    const url = '/wallet/api/transactions';
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getVinpayOrders: (
    params: BaseRequestQueryParam,
  ): Promise<HttpResponse<VinpayOrderResponseModel[]>> => {
    const url = '/wallet/api/transactions/partner';
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getFiatTransactions: (
    params: BaseRequestQueryParam,
  ): Promise<HttpResponse<FiatTransactionResponseModel[]>> => {
    const url = '/wallet/api/fiat-transactions';
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },

  orderSwapToken: (
    body: OrderSwapRequestModel,
  ): Promise<HttpResponse<OrderTransactionResponseModel[]>> => {
    const url = '/wallet/api/transactions/swap-token';
    return handleRequest(
      axiosClient.post(url, body, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  buyUsdAndTbet: (
    body: OrderSwapRequestModel,
  ): Promise<HttpResponse<OrderTransactionResponseModel[]>> => {
    const url = '/wallet/api/transactions/buy-token';
    return handleRequest(
      axiosClient.post(url, body, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getOrderSwapTransaction: (
    params: BaseRequestQueryParam,
  ): Promise<HttpResponse<OrderTransactionResponseModel[]>> => {
    const url = '/wallet/api/transactions/swap-token';
    return handleRequest(
      axiosClient.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default transactionApi;
